import React, { useRef, useState } from "react";
import { Modal } from "antd";
import { path } from "../../path";
import { toast } from "react-toastify";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { UPDATE_ACCOUNT } from "../../store/types/AuthTypes";

const AddPhoneModal = (props) => {
  const { isOpen, onClose, onDone } = props;
  
  const { user } = useSelector((state) => state.AuthReducer);
  const dispatch = useDispatch()
  const inputRef = useRef();

  const [loading, setLoading] = useState(false);

  const updateHandler = async () => {
    try {
        setLoading(true);
        const regex = /^\d{10}$/;
        const phone = inputRef.current.value;

        if(!phone || !regex.test(phone)) {
            toast.error("Contact number should be 10 digits!");
            return;
        }

        const body = { 
            updatedDetails: { phone },
            flag: false
        }

        const res = await axios.post(`${path}/updateAccount/${user._id}`, body);

        toast.success("Contact details updated successfully!");
        onClose();
        onDone();
        dispatch({ type: UPDATE_ACCOUNT, payload: res.data });
    } catch (error) {
        console.error(error)
        toast.error("There was a error updating contact details, please try again!");
    } finally {
        setLoading(false);
    }
  };

  const onCancelHandler = () => {
    onClose();
    onDone()
  }


  return (
    <Modal open={isOpen} title="Add Contact Details" onCancel={onCancelHandler} maskClosable={false} centered style={{ padding: 0 }} footer={[]}>
      <div className=" flex flex-col gap-2">
        <div className=" border-b-2 border-b-gray-200 flex flex-col gap-2 py-2">
          <p className="text-base tracking-tighter leading-snug">
            Add your number to get prize payouts fast 💸
          </p>
          <input ref={inputRef} className="outline-transparent text-base tracking-tighter leading-snug" type="text" placeholder="Phone no." />
        </div>
        <button type="button" 
        onClick={updateHandler}
        disabled={loading}
        className="flex justify-center items-center bg-teal-600 py-3 px-6 text-white text-base font-medium rounded-xl">
          {loading
            ? <span className="border-2 border-white border-t-transparent h-4 w-4 rounded-full animate-spin" ></span>
            : "Update"}
        </button>
      </div>
    </Modal>
  );
};

export default AddPhoneModal;